import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import styled from "styled-components";

import EmailLink from "./components/EmailLink";
import GitHubLineGraph from "./components/GitHubLineGraph";
import GlobalStyle from "./components/GlobalStyles";
import MainContent from "./components/MainContent";
import Navbar from "./components/Navbar";
import SocialMediaLinks from "./components/SocialMediaLinks";
import BlogPost from "./pages/BlogPost";
import BlogsList from "./pages/BlogsList"; // <-- Import BlogsList
import ContactPage from "./pages/ContactPage";
import FeaturedProjects from "./pages/FeaturedProjects";
import Skills from "./pages/Skills";

const AppWrapper = styled.div`
  background-color: #000000;
  color: #ffffff;
  min-height: 100vh;
`;

const AppContent = () => {
  const homeRef = useRef(null);
  const blogsRef = useRef(null);
  const githubRef = useRef(null); // <-- Add this
  const skillsRef = useRef(null);
  const projectsRef = useRef(null);
  const experienceRef = useRef(null);
  const contactRef = useRef(null);

  const location = useLocation();
  const [hideComponents, setHideComponents] = useState(false);

  useEffect(() => {
    if (location.pathname === "/contact") {
      setHideComponents(true);
      return;
    }

    const observerOptions = {
      root: null,
      threshold: 0.5,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.target.id === "contact-section") {
          setHideComponents(entry.isIntersecting);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (contactRef.current) {
      observer.observe(contactRef.current);
    }

    return () => {
      if (contactRef.current) {
        observer.unobserve(contactRef.current);
      }
    };
  }, [location.pathname]);

 const sections = [
    { id: "home", name: "HOME", ref: homeRef },
    //{ id: "blogs", name: "BLOGS", ref: blogsRef },
    { id: "github", name: "GITHUB", ref: githubRef }, // <-- Add this
    { id: "skills", name: "SKILLS", ref: skillsRef },
   
  ];

   return (
    <>
      <Navbar sections={sections} />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div ref={homeRef} id="home-section">
                <MainContent projectsRef={projectsRef} />
              </div>

              {/* <div ref={blogsRef} id="blogs-section">
                <BlogsAnimation />
              </div> */}

              <div ref={githubRef} id="github-section">
                <GitHubLineGraph username="konti-aditi" />
              </div>

              <div ref={skillsRef} id="skills-section">
                <Skills ref={skillsRef} />
              </div>

              <div ref={projectsRef} id="projects-section">
                <FeaturedProjects ref={projectsRef} />
              </div>

              

              <div ref={contactRef} id="contact-section">
                <ContactPage />
              </div>

              {!hideComponents && <SocialMediaLinks />}
              {!hideComponents && <EmailLink />}
            </>
          }
        />
        <Route path="/blogs-list" element={<BlogsList />} />
        <Route path="/blogs/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <>
      <GlobalStyle />
      <AppWrapper>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AppWrapper>
    </>
  );
};

export default App;